/* eslint-disable @nx/enforce-module-boundaries */
import dynamic from 'next/dynamic';
import { Container, MapTo } from '@adobe/aem-react-editable-components';
import '../../libs/aemComponents/Container';
import '../../libs/aemComponents/ExperienceFragment';

//SHOP COMPONENTS
import { AvailabilityCalendarEditable, HeadingComponent, HeroBannerAEM, AEMText } from '@marriott/mi-shop-components'; //TODO: import these from libs
import { HotelInformationComponentEditable } from '../../libs/mi-shop-components/src/organisms/HotelInformation/HotelInformationComponent';
import { HvmiBannerEditable } from '../../libs/mi-shop-components/src/organisms/HvmiBanner/HvmiBannerComponent';
import { HotelOverviewComponentEditable } from '../../libs/mi-shop-components/src/organisms/HotelOverview/HotelOverview';
import { HotelGalleryPhotoViewerComponentEditable } from '../../libs/mi-shop-components/src/organisms/HotelGalleryPhotoViewer/HotelGalleryPhotoViewerComponent';
import { AdobeClientDataLayer } from '../../libs/mi-shop-components/src/lib/organisms/AdobeClientDataLayer';
import { SearchFormComponentEditable } from '../../libs/mi-shop-components/src/lib/organisms/SearchForm/component/SearchForm';
import { TabbedSearchForm } from '../../libs/mi-shop-components/src/organisms/TabbedSearchForm/TabbedSearchForm';
import { SearchResultsComponentEditable } from '../../libs/mi-shop-components/src/organisms/SearchResults/SearchResultsComponent';
import { HQVWrapperEditable } from '../../libs/mi-shop-components/src/organisms/HQVWrapper';

//COMMON COMPONENTS
import { LinkBanner } from '../../libs/mi-common-static-components/src/organisms/LinkBanner';
import { CardCarouselContainer } from '../../libs/mi-common-static-components/src/organisms/CardCarouselContainer';
import { Footer } from '../../libs/mi-common-static-components/src/molecules/Footer';
import { StaticWrapper } from '../../libs/mi-common-static-components/src/organisms/StaticWrapper';

//BOOK COMPONENTS
import { HotelHeaderComponentEditable } from '@marriott/mi-book-components/organisms';
import { FlyoutDrawer } from '@marriott/mi-book-components';
import { AccountContainerEditable, SignInEditable, SignInContentBlockEditable } from '@marriott/mi-account-components';
import { respGridUtil } from '@marriott/mi-headless-utils';

//HOMEPAGE COMPONENTS
import { PropertyBarWrapper } from '../../libs/mi-homepage-components/src/organisms/PropertyBar/PropertyBarWrapper';

//DYNAMIC IMPORTS
const CardOverview = dynamic(() =>
  import('../../libs/mi-cobrand-components/src/organisms/CardOverview/CardOverview').then(mod => mod.CardOverview)
);

const EditableHTLWrapper = dynamic(() =>
  import('../../libs/mi-common-static-components/src/organisms/EditableHTLWrapper').then(mod => mod.EditableHTLWrapper)
);

const HotelGalleryTitleEditable = dynamic(() =>
  import('../../libs/mi-shop-components/src/organisms/HotelGalleryTitle/HotelGalleryTitle').then(
    mod => mod.HotelGalleryTitleEditable
  )
);

const MapAndRegionCardEditable = dynamic(() =>
  import('../../libs/mi-shop-components/src/organisms/MapAndRegionCard/MapAndRegionCard').then(
    mod => mod.MapAndRegionCardEditable
  )
);

const ExploreDestinationsEditable = dynamic(() =>
  import('../../libs/mi-shop-components/src/organisms/ExploreDestinations/ExploreDestinations').then(
    mod => mod.ExploreDestinationsEditable
  )
);

const SearchFormEditable = dynamic(() =>
  import('../../libs/mi-shop-components/src/organisms/SearchForm/SearchForm').then(mod => mod.SearchFormEditable)
);

const NGSearchFormEditable = dynamic(() =>
  import('../../libs/mi-shop-components/src/organisms/NGSearchForm/NGSearchForm').then(mod => mod.NGSearchFormEditable)
);

const MeetingsAndEventsSearchFormEditable = dynamic(() =>
  import('../../libs/mi-shop-components/src/organisms/MeetingsAndEventsSearchForm/MeetingsAndEventsSearchForm').then(
    mod => mod.MeetingsAndEventsSearchFormEditable
  )
);

const MerchBannerEditable = dynamic(() =>
  import('../../libs/mi-shop-components/src/organisms/MerchBanner/MerchBanner').then(mod => mod.MerchBannerEditable)
);

const CardLayered = dynamic(() =>
  import('../../libs/mi-common-static-components/src/organisms/CardLayered').then(mod => mod.CardLayered)
);

const CardVertical = dynamic(() =>
  import('../../libs/mi-common-static-components/src/organisms/CardVertical').then(mod => mod.CardVertical)
);

const CardHorizontalMini = dynamic(() =>
  import('../../libs/mi-common-static-components/src/organisms/CardHorizontalMini').then(mod => mod.CardHorizontalMini)
);

const CardHorizontalFeature = dynamic(() =>
  import('../../libs/mi-common-static-components/src/organisms/CardHorizontalFeature').then(
    mod => mod.CardHorizontalFeature
  )
);

const NavigationContainerWrapper = dynamic(() =>
  import('../../libs/mi-common-static-components/src/organisms/NavigationContainer').then(
    mod => mod.NavigationContainerWrapper
  )
);

const NavigationUtilityLinkWrapper = dynamic(() =>
  import('../../libs/mi-common-static-components/src/molecules/Navigation').then(
    mod => mod.NavigationUtilityLinkWrapper
  )
);

const NavigationWrapper = dynamic(() =>
  import('../../libs/mi-common-static-components/src/molecules/Navigation').then(mod => mod.NavigationWrapper)
);

const MerchandisingSmallBanner = dynamic(() =>
  import('../../libs/mi-merch-components/src/componentsWithDCAProvider').then(mod => mod.MerchandisingSmallBanner)
);

const MerchandisingBrandBannerComp = dynamic(() =>
  import('../../libs/mi-merch-components/src/componentsWithDCAProvider').then(mod => mod.MerchandisingBrandBannerComp)
);

export const AEM_REACT_MAPPING = {
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/hotelgallerytitle`]: HotelGalleryTitleEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/hotelinformation`]: HotelInformationComponentEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/headingcomponent`]: HeadingComponent,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/searchform/v1/searchform`]: SearchFormComponentEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/hotelgalleryoverview`]: HotelOverviewComponentEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/hotelgalleryphotoviewer`]:
    HotelGalleryPhotoViewerComponentEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/hqvwrapper`]: HQVWrapperEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/adobeclientdatalayer`]: AdobeClientDataLayer,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/herobanner/v1/herobanner`]: HeroBannerAEM,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/text`]: AEMText,
  [`mi-aem-common-spa/components/experiencefragment`]: Container,
  [`mi-aem-common-spa/components/common/staticwrapper`]: StaticWrapper,
  [`mi-aem-common-spa/components/content/cardlayered`]: CardLayered,
  [`mi-aem-common-spa/components/content/cardvertical`]: CardVertical,
  [`mi-aem-common-spa/components/content/cardhorizontalmini`]: CardHorizontalMini,
  [`mi-aem-common-spa/components/content/cardcarouselcontainer`]: CardCarouselContainer,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/availabilitycalendar/v1/availabilitycalendar`]:
    AvailabilityCalendarEditable,
  [`mcom-book-spa/components/prebooking/hotelheader`]: HotelHeaderComponentEditable,
  [`mi-aem-common-spa/components/content/cardhorizontalfeature`]: CardHorizontalFeature,
  'mi-aem-cobrand/components/content/cardoverview': CardOverview,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/mapsubregion/v1/mapsubregion`]: MapAndRegionCardEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/exploredestinations/v1/exploredestinations`]:
    ExploreDestinationsEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/baselinesearchform/v1/baselinesearchform`]:
    SearchFormEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/ngsearchform/v1/ngsearchform`]: NGSearchFormEditable,
  [`mi-aem-shop-spa/components/content/tabbedsearchformwrapper/v1/tabbedsearchformwrapper`]: TabbedSearchForm,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/meetingssearchform/v1/meetingssearchform`]:
    MeetingsAndEventsSearchFormEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/hvmibanner/v1/hvmibanner`]: HvmiBannerEditable,
  [`mi-aem-common-spa/components/content/linkbanner`]: LinkBanner,
  [`mi-aem-common-spa/components/content/merchandisingsmallbanner`]: MerchandisingSmallBanner,
  [`mi-aem-common-spa/components/content/brandbanner`]: MerchandisingBrandBannerComp,
  ['mi-aem-homepage-spa/components/content/universal-footer']: Footer,
  [`mi-aem-homepage-spa/components/content/global-navigation`]: NavigationContainerWrapper,
  [`mi-aem-homepage-spa/components/content/utilityNavigation`]: NavigationUtilityLinkWrapper,
  [`mi-aem-homepage-spa/components/content/primaryNavigation`]: NavigationWrapper,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/searchresults/v1/searchresults`]:
    SearchResultsComponentEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/merchbanner/v1/merchbanner`]: MerchBannerEditable,
  [`mi-aem-homepage-spa/components/content/propertybar`]: PropertyBarWrapper,
  [`mcom-book-spa/components/flyoutcontainer`]: FlyoutDrawer,
  [`mi-aem-account/components/content/accountcontainer`]: AccountContainerEditable,
  [`mi-aem-account/components/content/signin`]: SignInEditable,
  [`mi-aem-account/components/content/signincontentblock`]: SignInContentBlockEditable,
  [`mi-aem-account/components/content/datapagecomponent`]: Container,
};
export const defineComponentMapping = (
  allowedComponents,
  pagePath,
  isAuthorMode,
  locale,
  isBulgariDomain,
  NEXT_PUBLIC_BULGARI_URL,
  requestId,
  // Only availabilityCalendar.tsx sets this to true (via pageProps.isAdfPage). Used by the
  // hqvwrapper MapTo below so the shared HQVWrapper component knows to check the ADF feature
  // flag (EXPERIENCE_MCOM_SHOP_ADF_ZUSTAND) instead of the SERP one when authored on the ADF page.
  isAdfPage = false
) => {
  MapTo(`mi-aem-homepage-spa/components/content/propertybar`)(props => (
    <PropertyBarWrapper {...props} locale={locale} isAuthorMode={isAuthorMode} />
  ));
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/hotelgallerytitle`)(
    props => <HotelGalleryTitleEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'SmHotelGalleryTitle',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/content/linkbanner`)(
    props => <LinkBanner {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'LinkBanner',
      isEmpty: false,
    }
  );
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/merchbanner/v1/merchbanner`)(MerchBannerEditable, {
    emptyLabel: 'MerchBanner',
    isEmpty: false,
  });
  MapTo(`mi-aem-common-spa/components/content/merchandisingsmallbanner`)(MerchandisingSmallBanner, {
    emptyLabel: 'MerchandesingSmallBanner',
    isEmpty: false,
  });
  MapTo(`mi-aem-common-spa/components/content/brandbanner`)(MerchandisingBrandBannerComp, {
    emptyLabel: 'Feature Banner',
    isEmpty: false,
  });
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/hotelinformation`)(
    props => <HotelInformationComponentEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'HotelInformationComponent',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/common/staticwrapper`)(StaticWrapper, {
    emptyLabel: 'StaticWrapper',
    isEmpty: false,
  });
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/headingcomponent`)(HeadingComponent, {
    emptyLabel: 'HeadingComponent',
    isEmpty: false,
  });
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/searchform/v1/searchform`)(
    SearchFormComponentEditable,
    {
      emptyLabel: 'SearchForm',
      isEmpty: false,
    }
  );
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/hvmibanner/v1/hvmibanner`)(HvmiBannerEditable, {
    emptyLabel: 'HvmiBanner',
    isEmpty: false,
  });
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/ngsearchform/v1/ngsearchform`)(
    props => <NGSearchFormEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'NGSearchForm',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-shop-spa/components/content/tabbedsearchformwrapper/v1/tabbedsearchformwrapper`)(
    props => <TabbedSearchForm {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'TabbedSearchForm',
      isEmpty: false,
    }
  );
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/hotelgalleryoverview`)(HotelOverviewComponentEditable, {
    emptyLabel: 'HotelOverviewComponentEditable',
    isEmpty: false,
  });
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/hotelgalleryphotoviewer`)(
    HotelGalleryPhotoViewerComponentEditable,
    {
      emptyLabel: 'HotelGalleryPhotoViewerComponentEditable',
      isEmpty: false,
    }
  );
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/hqvwrapper`)(
    props => <HQVWrapperEditable {...props} isAuthorMode={isAuthorMode} isAdfPage={isAdfPage} />,
    {
      emptyLabel: 'HQVWrapper',
      isEmpty: false,
    }
  );
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/adobeclientdatalayer`)(AdobeClientDataLayer, {
    emptyLabel: 'AdobeClientDataLayer',
    isEmpty: false,
  });
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/text`)(AEMText, { emptyLabel: 'Text', isEmpty: false });
  MapTo(`mi-aem-common-spa/components/content/cardlayered`)(CardLayered, {
    emptyLabel: 'CardLayered',
    isEmpty: false,
  });
  MapTo(`mi-aem-common-spa/components/content/cardvertical`)(CardVertical, {
    emptyLabel: 'CardVertical',
    isEmpty: false,
  });
  MapTo(`mi-aem-common-spa/components/content/cardhorizontalmini`)(CardHorizontalMini, {
    emptyLabel: 'CardHorizontalMini',
    isEmpty: false,
  });

  MapTo(`mi-aem-common-spa/components/content/cardcarouselcontainer`)(
    props => <CardCarouselContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />,
    {
      emptyLabel: 'CardCarouselContainer',
      isEmpty: false,
    }
  );
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/availabilitycalendar/v1/availabilitycalendar`)(
    props => <AvailabilityCalendarEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'AvailabilityCalendarComponent',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/content/cardhorizontalfeature`)(CardHorizontalFeature, {
    emptyLabel: 'CardHorizontalFeature',
    isEmpty: false,
  });
  MapTo(`mi-aem-cobrand/components/content/cardoverview`)(CardOverview, {
    emptyLabel: 'CardOverview',
    isEmpty: false,
  });
  MapTo(`mcom-book-spa/components/prebooking/hotelheader`)(
    props => (
      <div className={`${props.model.styleclass} m-container-fullbleed`}>
        <HotelHeaderComponentEditable
          {...props}
          isAuthorMode={isAuthorMode}
          acceptLanguage={locale}
          isBulgariDomain={isBulgariDomain}
          NEXT_PUBLIC_BULGARI_URL={NEXT_PUBLIC_BULGARI_URL ?? ''}
          requestId={requestId}
        />
      </div>
    ),
    {
      emptyLabel: 'HotelHeaderComponent',
      isEmpty: false,
    }
  );
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/mapsubregion/v1/mapsubregion`)(
    props => <MapAndRegionCardEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'MapAndRegionCardEditable',
      isEmpty: false,
    }
  );
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/exploredestinations/v1/exploredestinations`)(
    props => <ExploreDestinationsEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'ExploreDestinationsComponent',
      isEmpty: false,
    }
  );
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/baselinesearchform/v1/baselinesearchform`)(
    props => <SearchFormEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'SearchForm',
      isEmpty: false,
    }
  );
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/meetingssearchform/v1/meetingssearchform`)(
    props => <MeetingsAndEventsSearchFormEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'MeetingsAndEventsSearchForm',
      isEmpty: false,
    }
  );
  MapTo('mi-aem-homepage-spa/components/content/universal-footer')(Footer, {
    emptyLabel: 'Footer',
    isEmpty: false,
  });
  MapTo(`mi-aem-homepage-spa/components/content/global-navigation`)(
    props => <NavigationContainerWrapper {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'NavigationContainerWrapper',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-homepage-spa/components/content/utilityNavigation`)(NavigationUtilityLinkWrapper, {
    emptyLabel: 'NavigationUtilityLinkWrapper',
    isEmpty: false,
  });
  MapTo(`mi-aem-homepage-spa/components/content/primaryNavigation`)(NavigationWrapper, {
    emptyLabel: 'NavigationWrapper',
    isEmpty: false,
  });
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/searchresults/v1/searchresults`)(
    SearchResultsComponentEditable,
    {
      emptyLabel: 'SearchResultsComponent',
      isEmpty: false,
    }
  );

  MapTo(`mcom-book-spa/components/flyoutcontainer`)(
    props => <FlyoutDrawer {...props.model} {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'FlyoutDrawer',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/accountcontainer`)(
    props => <AccountContainerEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'accountcontainer',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/signin`)(
    props => <SignInEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'signin',
    }
  );
  MapTo(`mi-aem-account/components/content/signincontentblock`)(
    props => <SignInContentBlockEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'signincontentblock',
    }
  );
  const DataPageVariationConfig = {
    emptyLabel: 'Data Page',

    isEmpty: function (props) {
      return !props || !props.configured;
    },
  };
  MapTo('mi-aem-account/components/content/datapagecomponent')(props => {
    const gridItems = props?.model?.cqItems?.responsivegrid?.[':items'];
    const isAccountContainer = gridItems ? Object.keys(gridItems)?.[0]?.includes('accountcontainer') : false;

    return (
      <Container
        isInEditor
        {...props}
        isPage={false}
        model={isAccountContainer ? respGridUtil(props?.model?.cqItems?.responsivegrid) : props?.model}
      />
    );
  }, DataPageVariationConfig);

  const existingMappings = Object.keys(AEM_REACT_MAPPING);
  if (allowedComponents) {
    allowedComponents.forEach(mapping => {
      const baseModelPath = '/jcr:content/root/responsivegrid/';
      const componentPath = mapping.path.split(baseModelPath)[1];

      if (existingMappings.indexOf(componentPath) === -1) {
        MapTo(componentPath)(EditableHTLWrapper, {
          emptyLabel: mapping.title,
          isEmpty: false,
        });
      }
    });
  }
};
